import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span className="footer-link-separator">|</span>
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>
        <div className="footer-copyright">
          &copy; {currentYear} The Icing Calculator. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
